import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { CombinedFacettenUrlService } from '../../services/facetten/combined-facetten-url.services';
import {
  BildungsBereich,
  BildungsbereichService
} from '../../services/state/bildungsbereich.service';
import { ModalPopupComponent } from '../modal/modal-popup/modal-popup.component';

@Component({
  selector: 'now-wbsuche-lib-bildungsbereich-aendern-card',
  imports: [CommonModule, ModalPopupComponent],
  templateUrl: `./bildungsbereich-aendern-card.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['bildungsbereich-aendern-card.component.scss']
})
export class BildungsbereichAendernCardComponent {
  @Input()
  public afterChangeFocusElementId = '';

  @ViewChild('bildungsbereichWechselnModal')
  public modal!: ModalPopupComponent;
  public bildungsbereichService = inject(BildungsbereichService);
  public combinedFacettenUrlService = inject(CombinedFacettenUrlService);
  private readonly document = inject(DOCUMENT);

  public cardText$ = this.bildungsbereichService.isUte$.pipe(
    map((isUte) => {
      if (isUte) {
        return `<p>Sie haben „Neuen Abschluss erwerben“ als Ziel Ihrer Weiterbildung gewählt.</p>
                <p>Ändern Sie die Auswahl zu „Wissen erweitern“: Sie erhalten Angebote für Kurse, mit denen Sie Ihr fachliches Wissen auffrischen, erweitern oder für den beruflichen Aufstieg ausbauen können.</p>`;
      }
      return `<p>Sie haben „Wissen erweitern“ als Ziel Ihrer Weiterbildung gewählt.</p>
              <p>Ändern Sie die Auswahl zu „Neuen Abschluss erwerben“: Sie erhalten Angebote für Umschulung, Teilqualifizierung und Vorbereitung zur Externenprüfung.</p>`;
    })
  );

  public nextBildungsbereich$: Observable<BildungsBereich> =
    this.bildungsbereichService.isUte$.pipe(
      map((isUte) => (isUte ? BildungsBereich.Erweitern : BildungsBereich.Erwerb))
    );

  public async setBildungsbereich() {
    const nextBildungsbereich = await firstValueFrom(this.nextBildungsbereich$);
    const showModal = await firstValueFrom(
      this.combinedFacettenUrlService.combinedFacetteParameters$.pipe(
        map((parameter) => parameter.filter(({ ids }) => ids.length > 0).length > 0)
      )
    );

    if (showModal) {
      this.modal.openModal();
      this.modal.primaryButtonClick.subscribe(() => {
        this.bildungsbereichService.setBildungsbereichAndResetFacetten(nextBildungsbereich);
        this.focusSucheingabeInputField();
      });
    } else {
      this.bildungsbereichService.setBildungsbereichAndResetFacetten(nextBildungsbereich);
      this.focusSucheingabeInputField();
    }
  }

  private focusSucheingabeInputField() {
    (this.document.querySelector(`#${this.afterChangeFocusElementId}`) as HTMLElement).focus();
  }
}
